import type { AdminCurrencyTotals } from "@ticketnjoy/types";

import { money } from "@/lib/format";

/** Para birimleri toplanmaz; her biri ayrı satır. */
export function CurrencyTotalsTable({
  rows,
  emptyText = "Bu dönemde satış yok.",
}: {
  rows: AdminCurrencyTotals[];
  emptyText?: string;
}) {
  if (rows.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyText}</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b text-left text-xs text-muted-foreground">
            <th className="py-2 pr-4 font-medium">Para birimi</th>
            <th className="py-2 pr-4 text-right font-medium">Sipariş</th>
            <th className="py-2 pr-4 text-right font-medium">Net satış</th>
            <th className="py-2 pr-4 text-right font-medium">İade</th>
            <th className="py-2 pr-4 text-right font-medium">Komisyon</th>
            <th className="py-2 pr-4 text-right font-medium">Servis ücreti</th>
            <th className="py-2 text-right font-medium">Platform geliri</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.currency} className="border-b last:border-0">
              <td className="py-2 pr-4 font-medium">{r.currency}</td>
              <td className="py-2 pr-4 text-right tabular-nums">
                {r.paidOrderCount.toLocaleString("tr-TR")}
              </td>
              <td className="py-2 pr-4 text-right tabular-nums">{money(r.netSales, r.currency)}</td>
              <td className="py-2 pr-4 text-right tabular-nums text-muted-foreground">
                {money(r.refundedTotal, r.currency)}
              </td>
              <td className="py-2 pr-4 text-right tabular-nums">{money(r.commission, r.currency)}</td>
              <td className="py-2 pr-4 text-right tabular-nums">{money(r.serviceFee, r.currency)}</td>
              <td className="py-2 text-right font-semibold tabular-nums">
                {money(r.platformRevenue, r.currency)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
